import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import { ReactComponent as VideoFileIcon } from '../../images/videocamera.svg';
import { ReactComponent as Prescriptions } from '../../images/prescription.svg';
import { ReactComponent as Diagnosis } from '../../images/diagnosis.svg';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import ItemButtonSimple from '../../components/shared/ItemButton';
import MyFilesV2ViewModel from './viewModel';
import FileItem from './FileListPage/FileItem';
import {
  HubContainer,
  ContentBlock,
  CategoryCardsRow,
  CategoryCard,
  CategoryCardIcon,
  CategoryCardLabel,
  RecentSection,
  SectionTitle,
  ViewMoreButton,
  CategoryListSection,
  EmptyStateText
} from './styled';
import Button from '@mui/material/Button';
import PrescriptionRenewalView from '../../components/pages/MyFilesV2/PrescriptionRenewal';
import CustomerService from '../../components/shared/PatientCareContact';
import { SessionLimiterStrong } from '../../components/shared/Divider';

export default function MyFilesV2() {
  const { isLoading, error, files, recentFiles, hasMore, loadMore, allFilesSorted } = MyFilesV2ViewModel();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress sx={{ color: 'brand.darkGreen' }} />
      </Box>
    );
  }

  if (error) {
    return <EmptyStateText>Não foi possível carregar os arquivos. Tente novamente.</EmptyStateText>;
  }

  return (
    <>
      <HubContainer>
        {/* Seção 1 + Seção 2 — bloco 320px centralizado com gap-32px */}
        <ContentBlock>
          {/* Seção 1 — Cards de categoria */}
          <CategoryCardsRow>
            <CategoryCard onClick={() => navigate('/meus-arquivos/pedidos-e-receita', { state: { files } })}>
              <CategoryCardIcon>
                <Prescriptions />
              </CategoryCardIcon>
              <CategoryCardLabel>Pedidos e receitas</CategoryCardLabel>
            </CategoryCard>

            <CategoryCard onClick={() => navigate('/meus-arquivos/relatorios', { state: { files } })}>
              <CategoryCardIcon>
                <Diagnosis />
              </CategoryCardIcon>
              <CategoryCardLabel>Relatórios</CategoryCardLabel>
            </CategoryCard>
          </CategoryCardsRow>

          {/* Seção 2 — Arquivos mais recentes */}
          <RecentSection>
            <SectionTitle>Arquivos mais recentes:</SectionTitle>

            {allFilesSorted.length === 0 ? (
              <EmptyStateText>Você ainda não possui arquivos</EmptyStateText>
            ) : (
              <>
                <Box>
                  {recentFiles.map((file, index) => (
                    <Box key={file.id}>
                      <FileItem file={file} />
                      {index < recentFiles.length - 1 && <Divider sx={{ borderColor: 'neutrals.beige3' }} />}
                    </Box>
                  ))}
                </Box>

                {hasMore && (
                  <ViewMoreButton>
                    <Button variant="inline" color="primary" onClick={loadMore}>
                      ver mais
                    </Button>
                  </ViewMoreButton>
                )}
              </>
            )}
          </RecentSection>
        </ContentBlock>

        <SessionLimiterStrong />
        {/* Divisor grosso entre seção 2 e seção 3 */}
        {/* <ThickDivider sx={{ my: 3 }} /> */}

        {/* Seção 3 — Lista de categorias */}
        <CategoryListSection>
          <ItemButtonSimple
            text="Declaração de comparecimento"
            icon={
              <Box component={'span'} sx={{ marginRight: 2 }}>
                <EditCalendarOutlinedIcon />
              </Box>
            }
            onClick={() => navigate('/meus-arquivos/declaracao-de-comparecimento', { state: { files } })}
            hasDivider={false}
          />
          {files && files?.surgicalVideos?.length > 0 && (
            <ItemButtonSimple
              text="Vídeo cirúrgico"
              icon={
                <Box component={'span'} sx={{ marginRight: 2 }}>
                  <VideoFileIcon />
                </Box>
              }
              onClick={() => navigate('/meus-arquivos/video-cirurgico', { state: { files } })}
            />
          )}

          {/* <ItemButtonSimple
            text="Outros"
            icon={<MedicalInformationOutlinedIcon sx={{ marginRight: 2 }} />}
            onClick={() => navigate('/meus-arquivos/outros', { state: { files } })}
          /> */}
        </CategoryListSection>
        <PrescriptionRenewalView />
        <SessionLimiterStrong />
      </HubContainer>
      <CustomerService />
    </>
  );
}
